

exports.__esModule = true;
exports.$DeleteShippingRoute = undefined;

var _squid = require('squid');

require('./directive');

var $DeleteShippingRoute = exports.$DeleteShippingRoute = _squid.$ComponentRoute.extend('$DeleteShippingRoute', {
    name: 'deleteShipping',
    directive: 'xo-delete-shipping',
    titleContent: 'asideHeader.deleteShipping',
    trackingData: {
        fptiState: 'delete_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::delete_shipping',
                'pagename2': '%::delete_shipping:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$DeleteShippingRoute", $DeleteShippingRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/delete-shipping/route.js
// module id = ../node_modules/xo-member-components/src/select-shipping/delete-shipping/route.js
// module chunks = 0